module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
   var _ = require('lodash');
   var moment = require('moment');
   var timeValue = specific;

   if(typeof showNow !== 'undefined' && u.isTrue(showNow)){
      if(moment(specific).year() === 1970){
          timeValue = new moment();
      }
   }
    
    var bHasSeconds = u.isTrue(hasSeconds);
    var bShowEmpty = u.isTrue(showEmpty);
    var bIs24HourClock = u.isTrue(is24HourClock);


    var formatTime = function (timeValue) {
    var template = "<div style='text-align: center; width: 27%; flex-grow:1;'>" + "*time*" + "</div>";
    var timeSplitted = timeValue.split(":");
    _.forEach(timeSplitted, function (time, index) {
        timeSplitted[index] = template.replace("*time*", time);
    });

    return timeSplitted.join(":");
}

if (bShowEmpty) {
    timeValue = formatTime(bHasSeconds ? ": :" : ":");
} else {
    timeValue = formatTime(u.getTime(timeValue, {use24Hour: bIs24HourClock, useSeconds: bHasSeconds}));
}

    ; __append("\r\n<style>\r\n    #")
    ; __append(escapeFn(id))
    ; __append(" div.updownicon-wrapper {\r\n        flex-grow:1; \r\n        display:flex; \r\n        align-items: center; \r\n        border: 1px solid black; \r\n        background-color: #eeeeee;\r\n    }\r\n\r\n    #")
    ; __append(escapeFn(id))
    ; __append(" div.updownicon {\r\n        width: 0;\r\n        height: ")
    ; __append(escapeFn( u.extractNum(height)/2 ))
    ; __append("; \r\n        border-left: 5px solid transparent; \r\n        border-right: 5px solid transparent; \r\n        margin-bottom: 0;\r\n    }\r\n</style>\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n            width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n            height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n            border-radius: 0px;\r\n            border: 1px none #ffffff;\r\n            z-index: ")
    ; __append(escapeFn( zOrder ))
    ; __append(";\r\n            display:flex\">\r\n\r\n    <div class=\"size-handle-top\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  + 4  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable\" style=\"flex-grow:1;\" >\r\n        <div style=\"margin: 0px;\r\n                align-items : center;\r\n                height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n                    -webkit-border-radius: 0px;\r\n                    -moz-border-radius: 0px;\r\n                border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n                font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n                font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n                text-align: center;\r\n                line-height: ")
    ; __append(escapeFn( u.extractNum(height) - 1 ))
    ; __append("px;\r\n                background-color: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n                margin-right: 17px;\">\r\n\r\n            <div style=\"\r\n                  margin-left: auto;\r\n                  margin-right: auto;\r\n                  position: relative;\r\n                  overflow: hidden;\r\n                  display:flex;\">\r\n                ")
    ; __append(timeValue)
    ; __append("\r\n            </div>\r\n        </div>\r\n        <div style=\"display:flex; flex-direction:column; position:absolute; top:0; right:0; height:100%;\">\r\n            <span class=\"timeEntry_control\" style=\"display: inline-block; background: url('")
    ; __append( require('editor/icons/spinnerUpDownnew.png') )
    ; __append("') 0 0 no-repeat; width: 15px; height: 24px;\" title=\"Increment\"></span>\r\n            \r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  + 4  ))
    ; __append("px;\"></div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}